import * as THREE from 'three'
import { Object3D } from 'three'
import {
  ColladaLoader,
  FBXLoader,
  GLTFLoader,
  OBJLoader,
  PLYLoader,
  STLLoader,
  TDSLoader,
} from 'three-stdlib'
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter'

export const loadGLTFModel = (url: string): Promise<Object3D> => {
  return new Promise((resolve, reject) => {
    const loader = new GLTFLoader()
    loader.load(
      url,
      (gltf) => {
        resolve(gltf.scene)
      },
      undefined,
      (error) => {
        reject(error)
      },
    )
  })
}

export const loadSTLModel = (url: string): Promise<Object3D> => {
  return new Promise((resolve, reject) => {
    const loader = new STLLoader()
    loader.load(
      url,
      (geometry) => {
        const material = new THREE.MeshStandardMaterial()
        const mesh = new THREE.Mesh(geometry, material)
        resolve(mesh)
      },
      undefined,
      (error) => {
        reject(error)
      },
    )
  })
}

export const load3DSModel = (url: string): Promise<Object3D> => {
  return new Promise((resolve, reject) => {
    const loader = new TDSLoader()
    loader.load(
      url,
      (object) => {
        // Convertir materiales a MeshStandardMaterial o MeshBasicMaterial
        object.traverse((child) => {
          if (child.isMesh) {
            if (
              !(
                child.material instanceof THREE.MeshStandardMaterial ||
                child.material instanceof THREE.MeshBasicMaterial
              )
            ) {
              child.material = new THREE.MeshStandardMaterial({ map: child.material.map })
            }
          }
        })
        resolve(object)
      },
      undefined,
      (error) => {
        reject(error)
      },
    )
  })
}

export const loadDAEModel = (url: string): Promise<Object3D> => {
  return new Promise((resolve, reject) => {
    const loader = new ColladaLoader()
    loader.load(
      url,
      (collada) => {
        resolve(collada.scene)
      },
      undefined,
      (error) => {
        reject(error)
      },
    )
  })
}

export const loadOBJModel = (url: string): Promise<Object3D> => {
  return new Promise((resolve, reject) => {
    const loader = new OBJLoader()
    loader.load(
      url,
      (object) => {
        resolve(object)
      },
      undefined,
      (error) => {
        reject(error)
      },
    )
  })
}

export const loadFBXModel = (url: string): Promise<Object3D> => {
  return new Promise((resolve, reject) => {
    const loader = new FBXLoader()
    loader.load(
      url,
      (object) => {
        resolve(object)
      },
      undefined,
      (error) => {
        reject(error)
      },
    )
  })
}

export const loadPLYModel = (url: string): Promise<Object3D> => {
  return new Promise((resolve, reject) => {
    const loader = new PLYLoader()
    loader.load(
      url,
      (geometry) => {
        const material = new THREE.MeshStandardMaterial()
        const mesh = new THREE.Mesh(geometry, material)
        resolve(mesh)
      },
      undefined,
      (error) => {
        reject(error)
      },
    )
  })
}

export const convertToGLB = (object: Object3D): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const exporter = new GLTFExporter()
    const options = {
      binary: true,
      embedImages: true,
      forcePowerOfTwoTextures: true,
      maxTextureSize: 4096,
    }
    exporter.parse(
      object,
      (result) => {
        let blob
        if (result instanceof ArrayBuffer) {
          blob = new Blob([result], { type: 'application/octet-stream' })
        } else {
          const json = JSON.stringify(result)
          blob = new Blob([json], { type: 'application/json' })
        }
        resolve(blob)
      },
      (error) => {
        reject(error)
      },
      options,
    )
  })
}

export const convertBlobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      const base64 = reader.result?.toString().split(',')[1]
      if (base64) resolve(base64)
      else reject('Error al convertir a Base64')
    }
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}
